import { useSyncExternalStore } from 'react'

/**
 * DANGEROUS: DO NOT USE. Well... usually don't use. This is incompatible with SSR.
 */
export function useMediaQuery(query: string): boolean {
  const matches = useSyncExternalStore(
    (callback) => {
      const matchMedia = window.matchMedia(query)
      // Listen matchMedia
      if (matchMedia.addListener) {
        matchMedia.addListener(callback)
      } else {
        matchMedia.addEventListener('change', callback)
      }

      return () => {
        if (matchMedia.removeListener) {
          matchMedia.removeListener(callback)
        } else {
          matchMedia.removeEventListener('change', callback)
        }
      }
    },
    () => window.matchMedia(query).matches,
    () => false
  )

  return matches
}
